const config = {
  url: '/podcast-one-series/:id',
  getTitle: id => id === 'create' ? 'Создание серии подкаста' : 'Редактирование серии подкаста',
  getApiUrl: id => id === 'create' ? '/podcast-series' : `/podcast-series/${id}`,
  type: 'card',
  access: ['*'],
  tabs: [
    {
      key: 'common',
      title: 'Общее',
      children: {
        left: [
          {
            key: 'name',
            title: 'Название',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
        ],
        right: [
          {
            key: 'name_en',
            title: 'Название (en)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
        ],
        both: [],
      }
    }
  ]
}

export default config
